/**
 * Разделы уведомлений — те же, что на сервере (backend utils/notificationCategory.js).
 * Сервер сам пишет раздел в уведомление (поле category), фильтрует и считает по нему.
 * Здесь — только подписи и запасное определение для старых уведомлений.
 */

export const NOTIFICATION_CATEGORIES = [
    { key: "chat", label: "Сообщения", short: "Сообщение" },
    { key: "task", label: "Задания", short: "Задание" },
    { key: "order", label: "Заказы", short: "Заказ" },
    { key: "billing", label: "Биллинг", short: "Биллинг" },
    { key: "inventory", label: "Склад", short: "Склад" },
    { key: "system", label: "Система", short: "Система" },
    { key: "other", label: "Прочее", short: "Уведомление" },
];

const KEYS = NOTIFICATION_CATEGORIES.map((item) => item.key);

export const emptyCategoryCounts = () => Object.fromEntries(KEYS.map((key) => [key, 0]));

export const getNotificationCategory = (notification = {}) => {
    if (KEYS.includes(notification?.category)) return notification.category;

    const type = String(notification?.type || "").toLowerCase();
    const event = String(notification?.meta?.event || "").toLowerCase();

    if (type === "chat" || event === "chat_message" || event.startsWith("chat_")) return "chat";
    if (event.startsWith("office_task_") || event.startsWith("task_")) return "task";
    if (type === "payment" || type === "billing" || event.startsWith("billing_") || event.includes("payment")) return "billing";
    if (type === "order" || event.includes("order")) return "order";
    if (event.includes("inventory") || event.includes("warehouse") || event.includes("stock")) return "inventory";
    if (type === "system") return "system";
    return "other";
};

export const getCategoryLabel = (key, short = false) => {
    const item = NOTIFICATION_CATEGORIES.find((entry) => entry.key === key);
    if (!item) return short ? "Уведомление" : "Прочее";
    return short ? item.short : item.label;
};

/** Подпись на карточке: для приглашений и событий офиса — «Офис», а не «Прочее». */
export const getNotificationBadgeLabel = (notification = {}) => {
    const category = getNotificationCategory(notification);
    if (category === "other" && String(notification?.type || "") === "office") return "Офис";
    if (category === "other" && String(notification?.type || "") === "custom") return "Уведомление";
    return getCategoryLabel(category, true);
};

export const normalizeCategoryCounts = (value = {}) => {
    const result = emptyCategoryCounts();
    if (!value || typeof value !== "object") return result;

    KEYS.forEach((key) => {
        result[key] = Math.max(Number(value[key] || 0), 0);
    });

    return result;
};
